import { Button } from "@mui/material";
import classNames from "classnames";

export const CustomButton = ({
  children,
  className = "",
  size = "small",
  variant = "contained",
  type = "",
  disabled = false,
  onClick,
  startIcon,
}) => {
  return (
    <Button
      disableElevation
      variant={variant}
      startIcon={startIcon}
      className={classNames("!capitalize ", className)}
      size={size}
      disabled={disabled}
      type={type}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};
